import Swiper, {Navigation, Scrollbar} from "swiper";

document.addEventListener("DOMContentLoaded", () => {
  const tables = document.querySelectorAll(".js-table-swiper");

  if(tables.length) {
    tables.forEach(table => {
      let tableSwipper = table.querySelector('.table__swiper');
      let navButtonNext = table.querySelector('.table__navigation-item.table__navigation-item--next')
      let navButtonPrev = table.querySelector('.table__navigation-item.table__navigation-item--prev')
      let scrollbar = table.querySelector('.table__scrollbar')

      const swiperTable = new Swiper(tableSwipper, {
        modules: [Navigation, Scrollbar],
        breakpoints: {
          1440: {
            slidesPerView: 8,
          },
          1024: {
            slidesPerView: 6,
          },
          700: {
            slidesPerView: 5
          },
          300: {
            slidesPerView: "auto",
            allowTouchMove: true
          }
        },
        allowTouchMove: false,
        navigation: {
          nextEl: navButtonNext,
          prevEl: navButtonPrev
        },
        scrollbar: {
          el: scrollbar,
          draggable: true
        }
      })
    })
  }
})
